export interface PracticeAnalyticsPayload {
  cohorts: number[];
}

export interface CreatePracticePayload {
  name: string;
  org_id: string | null;
  analytics?: PracticeAnalyticsPayload;
}

export function withPracticeAnalytics(
  payload: Omit<CreatePracticePayload, 'analytics'>,
  cohortIds: number[]
): CreatePracticePayload {
  return {
    ...payload,
    analytics: {
      cohorts: cohortIds,
    },
  };
}
